var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 可拖拽排序的组件槽位
 * 使用 @dnd-kit/sortable 包裹子组件，将拖动手柄注入子组件的 titleLeftAdornment，显示在 panel 标题栏标题左侧
 */
import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MoreOutlined } from "@ant-design/icons";
var handleStyle = {
    cursor: "grab",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};
/** 将 titleLeftAdornment 注入业务组件（children 结构为 wrapSlot > slotWrapper > Component） */
function injectTitleLeftAdornment(node, adornment) {
    var _a, _b;
    if (!React.isValidElement(node))
        return node;
    var outer = node;
    var inner = (_a = outer.props) === null || _a === void 0 ? void 0 : _a.children;
    if (!React.isValidElement(inner)) {
        return React.cloneElement(outer, { titleLeftAdornment: adornment });
    }
    var comp = (_b = inner.props) === null || _b === void 0 ? void 0 : _b.children;
    if (!React.isValidElement(comp)) {
        return React.cloneElement(outer, {}, React.cloneElement(inner, { titleLeftAdornment: adornment }));
    }
    var compWithAdornment = React.cloneElement(comp, {
        titleLeftAdornment: adornment,
    });
    return React.cloneElement(outer, {}, React.cloneElement(inner, {}, compWithAdornment));
}
export var SortableComponentSlot = function (_a) {
    var id = _a.id, children = _a.children;
    var _b = useSortable({ id: id }), attributes = _b.attributes, listeners = _b.listeners, setNodeRef = _b.setNodeRef, transform = _b.transform, transition = _b.transition, isDragging = _b.isDragging;
    var style = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.5 : 1,
        width: "100%",
        minWidth: 0,
        /** 与父级 grid 的 align-items:start 一致，避免格子被同行最高项拉高 */
        alignSelf: "start",
    };
    var handleElement = (_jsx("div", __assign({}, attributes, listeners, { style: handleStyle, title: "\u62D6\u62FD\u8C03\u6574\u4F4D\u7F6E", onClick: function (e) { return e.stopPropagation(); } }, { children: _jsx(MoreOutlined, { style: { fontSize: 14, color: "#999" } }) })));
    var childWithHandle = injectTitleLeftAdornment(children, handleElement);
    return (_jsx("div", __assign({ ref: setNodeRef, style: style }, { children: childWithHandle })));
};
